export default __webpack_public_path__ + "0b7616e4c65e3435c3e64f454b371cf1.png";